const frontendRoutes = {
  LANDING: "/",
  HOME: "/feed",
  SEARCH: "/search",
  LOGIN: "/login",
  VIEW_PRODUCT: "/product/:productId",
  // Also matches handle-based shop links (e.g. "/shop/@chiso-naturals") — ShopPage
  // detects the "@" prefix on :shopId and resolves by handle instead.
  VIEW_SHOP: "/shop/:shopId",
  VIEW_USER: "/user/:userId",
  USER_FOLLOWERS: "/user/:userId/followers",
  USER_FOLLOWING: "/user/:userId/following",
  SHOP_FOLLOWERS: "/shop/:shopId/followers",
  PRODUCT_REVIEWS: "/product/:productId/reviews",
  SHOP_REVIEWS: "/shop/:shopId/reviews",
  MY_CART: "/my-cart",
  USER_PROFILE: "/user/profile",
  ACCOUNT_SETTINGS: "/user/settings",
  NOTIFICATION_SETTINGS: "/user/settings/notifications",
  ADMIN_ROOT: "/admin",
  ADMIN_ANALYTICS: "/admin/analytics",
  ADMIN_DISPUTES: "/admin/disputes",
  ADMIN_DISPUTE_DETAIL: "/admin/disputes/:orderId",
  ADMIN_REPORTS: "/admin/reports",
  ADMIN_REPORT_DETAIL: "/admin/reports/:reportId",
  ADMIN_USERS: "/admin/users",
  ADMIN_USER_DETAIL: "/admin/users/:userId",
  ADMIN_SHOPS: "/admin/shops",
  ADMIN_SHOP_DETAIL: "/admin/shops/:shopId",
  ADMIN_ORDERS: "/admin/orders",
  ADMIN_ORDER_DETAIL: "/admin/orders/:orderId",
  ADMIN_PRODUCTS: "/admin/products",
  ADMIN_PRODUCT_DETAIL: "/admin/products/:productId",
  ADMIN_VERIFICATIONS: "/admin/verifications",
  ADMIN_VERIFICATION_DETAIL: "/admin/verifications/:userId",
  ADMIN_FEATURE_FLAGS: "/admin/feature-flags",
  ADMIN_FEEDBACK: "/admin/feedback",
  WHAT_IS_NGWAAHIA: "/what-does-ngwaahia-mean",
  PRIVACY_POLICY: "/privacy-policy",
  TERMS_OF_SERVICE: "/terms-of-service",
  DELETE_ACCOUNT: "/delete-account",
  SUPPORT: "/support",
  HELP: "/help",
  HELP_CATEGORY: "/help/:categorySlug",
  HELP_ARTICLE: "/help/:categorySlug/:articleSlug",
  // Long-form narrative pages. STORY is the route pattern; the literal path
  // below is what other pages link to. Both are kept honest by the content
  // build, which fails if a story's frontmatter `path` leaves /stories/.
  // Blog and think pieces slot in here later as further slugs.
  STORY: "/stories/:slug",
  STORY_HOW_TO_USE: "/stories/how-to-use-ngwaahia",
  // The credit roll. CREDITS_PERSON renders the same page opened on one
  // person, so each contributor has a link to their own credit that they can
  // confirm and reshare. The paths are generated into public/doc-routes.json by
  // the content build, which is what gives each one its own preview card.
  CREDITS: "/roll-credits",
  CREDITS_PERSON: "/roll-credits/:personSlug",
  // Universal-link fallbacks for mobile-only screens (no web page exists at these
  // paths — they render OpenInApp). Paths must match utility/appLinkPaths.js'
  // SCREEN_TO_PATH on the backend, and the .well-known/apple-app-site-association
  // "paths" array, so the app can intercept them before this page ever loads.
  OPEN_IN_APP_VERIFY_PHONE: "/verify-phone",
  OPEN_IN_APP_ADD_ADDRESS: "/add-address",
  OPEN_IN_APP_INTERESTS: "/interests",
  OPEN_IN_APP_EDIT_PROFILE: "/edit-profile",
  OPEN_IN_APP_SETUP_SHOP: "/setup-shop",
  OPEN_IN_APP_MY_SHOP: "/my-shop",
  OPEN_IN_APP_ORDER: "/order",
  OPEN_IN_APP_SHOP_ORDER: "/shop-order",
};

// Query param that lets a logged-in user land on "/" without being bounced
// to the feed — LandingPage checks for it, AppFooter's "back to landing"
// link sets it. Without this, that link would be a no-op for exactly the
// audience it's for (a logged-in user is otherwise always redirected away).
const LANDING_STAY_QUERY_PARAM = "stay";

export { frontendRoutes, LANDING_STAY_QUERY_PARAM };
